import React from "react";
import { ContractsAndJudicialDocumentsTypes, MessageStatus, RootCategoriesTypes } from "../../../constant/Types";
import {
  calcBytes,
  downloadWithAxios,
  getHoursMinutesTime,
  trimDoubleQuotes,
} from "../../../constant/helper";
import { ReactComponent as LogoIcon } from "../../../images/logo.svg";
import { ReactComponent as FilePDFIcon } from "../../../images/chat/file-pdf.svg";
import AvatarPreview from "../../profile/components/AvatarPreview";
import MessageDateCategories from "./MessageDateCategories";
import { getFileService } from "../chat.api";
import { scrollTo } from '../utils/scrollTo'

const MediaMessageLawyer = (props) => {
  const {
    rootType,
    data,
    meta,
    time,
    status,
    openPdfEditorHandler,
    messagesList,
    index,
    currentlyItem,
    setLoading,
  } = props;
  const { size, filename, name, link } = data;
  const { id, fileId } = meta;

  let statusResult =
    status === MessageStatus.sending || status === MessageStatus.failed
      ? status
      : "DONE";

  const handleMessageClick = async () => {
    let finalFileName = filename || name || "";
    let fileLink = link;

    if (
      finalFileName &&
      rootType !== {...RootCategoriesTypes, ...ContractsAndJudicialDocumentsTypes}.consulting_and_reviewing_documents &&
      (finalFileName.search(".doc") > 0 || finalFileName.search(".docx") > 0)
    ) {
      if (!fileLink && fileId) {
        setLoading(true);
        const file = await getFileService(fileId);
        fileLink = file?.data?.fileExtraInfo?.fileUrl;
      }
      downloadWithAxios(
        fileLink,
        `${finalFileName ? finalFileName : Math.random() + ".docx"}`,
        setLoading
      );
    } else {
      if (
        !(finalFileName.search(".doc") > 0 || finalFileName.search(".docx") > 0)
      ) {
        openPdfEditorHandler(fileLink, fileId ? fileId : id);
      }
    }
  };

  return (
    <React.Fragment>
      <MessageDateCategories
        className={{
          textAlign: "center",
          color: "#656567",
          fontWeight: "400",
          fontSize: "14px",
          marginBottom: "1rem",
        }}
        messagesList={messagesList}
        index={index}
        currentlyItem={currentlyItem}
      />
      <div
        // className={`msg msg-lawyer-holder msg-media-client ${
        className={`msg msg-media ${
          statusResult === "DONE" ? "msg-media-done" : ""
        }`}
        style={{ marginRight: "auto" }}
        id={id}
      >
        <div className="msg-wrapper">
          <div
            className="msg-holder"
            onClick={
              handleMessageClick
              //  openPdfEditorHandler(link, fileId);
            }
          >
            {statusResult === "DONE" ? (
              <div className={"msg-avatar-bg"}>
                <div className={"msg-avatar-holder"}>
                  <div className={"msg-avatar"}>
                    <AvatarPreview
                      isSvg={false}
                      src={currentlyItem.otherProfile || "LAWONE"}
                    />{" "}
                  </div>
                </div>
              </div>
            ) : (
              <div className="msg-status">
                <div className={`loading-holder ${statusResult}`}>
                  <div className="loading-circle">
                    <div className={`loading-wave mid`}>
                      <span className="percent-text"> {statusResult} </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {data.inReplyToTheMessage && <div className="msg-in-reply-text" onClick={() => scrollTo(data.inReplyToTheMessage.id)}>{trimDoubleQuotes(data.inReplyToTheMessage.text || data.inReplyToTheMessage.filename)}</div>}
            <div className="msg-file-wrapper">
              <div className="msg-file-icon">
                <FilePDFIcon />
              </div>
              <div className="msg-data ltr">
                {filename && <div className="msg-text">{filename}</div>}
                {size && <div className="msg-text">{calcBytes(size)}</div>}
              </div>
            </div>
          </div>
          <div className={"msg-time"}>{time && getHoursMinutesTime(time)}</div>
          <div className="msg-bg-holder">
            <span className={"msg-logo-bg"}>
              <LogoIcon />
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MediaMessageLawyer;
